var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgForexNav = function SvgForexNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33658A",
    d: "M26 0a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 8v4H9v3h5v3H9v6H5V8h11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m13 8 4.5 7.5L13 24h4l3-5 3 5h4l-4.5-8.5L27 8h-4.5L20 12l-2.5-4z"
  }))));
};

export { SvgForexNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjMzM2NThBIiBkPSJNMjYgMGE2IDYgMCAwIDEgNiA2djIwYTYgNiAwIDAgMS02IDZINmE2IDYgMCAwIDEtNi02VjZhNiA2IDAgMCAxIDYtNmgyMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTYgOHY0SDl2M2g1djNIOXY2SDVWOGgxMXoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJtMTMgOCA0LjUgNy41TDEzIDI0aDRsMy01IDMgNWg0bC00LjUtOC41TDI3IDhoLTQuNUwyMCAxMmwtMi41LTR6Ii8+PC9nPjwvc3ZnPg==";